import React from 'react'
import { useCopyToClipboard } from 'react-use'
import { useTranslate } from 'react-polyglot'
import { Title, Text } from 'components/typo'
import Button from 'components/shared/Button'
import Code from 'components/shared/Code'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const EditorsPicksCard = ({ className, title, text, commandLine }) => {
  const t = useTranslate()
  const [_, copyToClipboard] = useCopyToClipboard()

  return (
    <div id="editor-pick-card" className={cx(className, css.EditorsPicksCard)}>
      <div className={css.topPattern} />
      <div className={css.bottomPattern} />
      <div className={css.content}>
        {title && (
          <Title className={css.title} theme="white" size="small">
            {title}
          </Title>
        )}
        {text && (
          <Text className={css.text} theme="white" size="small">
            {text}
          </Text>
        )}
        {commandLine && (
          <Code
            className={css.codeBlock}
            theme="green"
            content={commandLine}
            noMargin
          />
        )}
        <Button
          id={title}
          tagName="button"
          className={css.button}
          fullWidth
          theme="white-green"
          onClick={() => copyToClipboard(commandLine)}
        >
          {t('action.copy')}
        </Button>
      </div>
    </div>
  )
}

EditorsPicksCard.defaultProps = {}

export default EditorsPicksCard
